
// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import "./McqOfTheDay.css";
// import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
// import InfoIcon     from "../../../Assets/Images/CommanImages/Informative.png";
// import ErrorIcon    from "../../../Assets/Images/CommanImages/Error.png";
// import DropDownFilterTags      from "../QuestionPaperDetails/DropDownFilterTags";
// import SectionSelectedDropdown from "../QuestionPaperDetails/SectionSelectedDropdown";
// import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
// import TableDetailsQuesList    from "../QuestionPaperDetails/TableDetailsQuesList";
// import TableDetailsSelectedQues from "./TableDetailsSelectedQuestions";
// import Endpoints from "../../../Api/Endpoints";

// const FREQUENCY_OPTIONS = [
//   { id: "daily",     label: "Daily" },
//   { id: "alternate", label: "Alternate Days (Every 2 days)" },
//   { id: "every3",    label: "Once in 3 Days" },
//   { id: "every4",    label: "Once in 4 Days" },
//   { id: "weekly",    label: "Weekly" },
// ];
// const NUM_QUES_OPTIONS = [{ id: 1, label: "1" }, { id: 2, label: "2" }, { id: 3, label: "3" }];

// function buildDateList(from, to, freq) {
//   if (!from || !to || !freq) return [];
//   const start = new Date(from), end = new Date(to);
//   if (start > end) return [];
//   const step = freq === "daily" ? 1 : freq === "alternate" ? 2 : freq === "every3" ? 3 : freq === "every4" ? 4 : 7;
//   const dates = [];
//   for (let d = new Date(start); d <= end; d.setDate(d.getDate() + step))
//     dates.push(d.toISOString().split("T")[0]);
//   return dates;
// }

// export default function McqOfTheDay({
//   dataClient, setMessageBox, messageBox,
//   setIsMessageBoxVisible, setActiveImg, setNoTimeSet,
// }) {
//   const navigate    = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userId         = dataClient?.client_schema_name?.[6]?.[0]?.user_id           || null;
//   const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name         || "";

//   // ── Section 1: Date Range ────────────────────────────────────────────────
//   const [fromDate,     setFromDate]     = useState("");
//   const [toDate,       setToDate]       = useState("");
//   const [frequency,    setFrequency]    = useState("");
//   const [numQuestions, setNumQuestions] = useState("");
//   const [isOpenDateRange,    setIsOpenDateRange]    = useState(true);
//   const [isOpenSubjectTags,  setIsOpenSubjectTags]  = useState(true);

//   const dateRangeComplete = !!(fromDate && toDate && frequency && numQuestions);
//   const dateList = useMemo(() => buildDateList(fromDate, toDate, frequency), [fromDate, toDate, frequency]);
//   const totalSlotsRequired = dateList.length * (numQuestions || 0);
//   const customSectionOptions = useMemo(() => dateList.map((d) => ({ id: d, label: d })), [dateList]);

//   // ── Subject + Tags ───────────────────────────────────────────────────────
//   const [courses, setCourses]   = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [selectedCourseId,  setSelectedCourseId]  = useState("");
//   const [selectedSubjectId, setSelectedSubjectId] = useState("");
//   const [selectedChapterIds, setSelectedChapterIds] = useState([]); // array
//   const [selectedTopicIds,   setSelectedTopicIds]   = useState([]); // array
//   const [topicsByChapter,    setTopicsByChapter]    = useState({}); // { chapterId: [topicId,...] }
//   const [topicNameMap,       setTopicNameMap]       = useState({}); // { topicId: topicName }
//   const [allTopicsLoaded,    setAllTopicsLoaded]    = useState(false);
//   const [tags, setTags]           = useState([]);
//   const [selectedTags, setSelectedTags] = useState([]);

//   // ── Question list state ──────────────────────────────────────────────────
//   const [reportDashboardData,  setReportDashboardData]  = useState([]);
//   const [selectedQuestions,    setSelectedQuestions]    = useState([]);
//   const [selectedHeaders,      setSelectedHeaders]      = useState([]);
//   const [selectedRows,         setSelectedRows]         = useState([]);
//   const [difficultyCount,      setDifficultyCount]      = useState({});
//   const [showFlagModal,        setShowFlagModal]        = useState(false);
//   const [version,              setVersion]              = useState(0);
//   const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});

//   const activeSubjectKey = selectedSubjectId ? parseInt(selectedSubjectId) : "mcqday";

//   // Guarded version bump — blocks question selection when all slots are full
//   const handleVersionChange = useCallback((updater) => {
//     const newVersion = typeof updater === "function" ? updater(version) : updater;
//     const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     const newCount = (selMap[activeSubjectKey] || []).length;

//     // Only block if date range is configured AND new count exceeds total slots
//     if (dateRangeComplete && totalSlotsRequired > 0 && newCount > totalSlotsRequired) {
//       // Immediately remove the last added question
//       const key = String(activeSubjectKey);
//       const ids = selMap[key] || [];
//       const removedId = ids[ids.length - 1];
//       selMap[key] = ids.slice(0, -1);
//       localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));

//       // Also clean deleted map so re-select works cleanly
//       const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
//       delMap[key] = [...new Set([...(delMap[key] || []), removedId])];
//       localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

//       setActiveImg(WarnningIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>
//               ⚠ All {totalSlotsRequired} slot{totalSlotsRequired !== 1 ? "s" : ""} are filled
//               ({dateList.length} date{dateList.length !== 1 ? "s" : ""} × {numQuestions} per day).
//               Please deselect a question or expand the date range before adding more.
//             </span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//     }

//     setVersion(newVersion);
//   }, [version, activeSubjectKey, dateRangeComplete, totalSlotsRequired, dateList, numQuestions]);

//   // Live count from localStorage
//   const [selectedCount, setSelectedCount] = useState(0);
//   useEffect(() => {
//     const m = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     setSelectedCount((m[activeSubjectKey] || []).length);
//   }, [version, activeSubjectKey]);

//   const showUnderWarning = dateRangeComplete && selectedCount > 0 && selectedCount < totalSlotsRequired;
//   const showOverWarning  = dateRangeComplete && selectedCount > totalSlotsRequired;

//   // ── Filters ──────────────────────────────────────────────────────────────
//   // Compute the topic IDs that should go into the filter for a given chapter:
//   // - If user has manually picked specific topics → use only those
//   // - Otherwise → use all topics for that chapter from topicsByChapter
//   const getTopicsForChapter = useCallback((chapterId) => {
//     const allForChapter = topicsByChapter[chapterId] || [];
//     if (selectedTopicIds.length === 0) return allForChapter; // no manual filter → all
//     // Keep only topic IDs that belong to this chapter AND are selected
//     return selectedTopicIds.filter((tid) => allForChapter.includes(tid));
//   }, [selectedTopicIds, topicsByChapter]);

//   const filters = useMemo(() => {
//     if (!selectedSubjectId || !allTopicsLoaded) return []; // gate: wait for topics
//     // Which chapters to include: if user picked specific ones → those; else all
//     const chapsToUse = selectedChapterIds.length > 0
//       ? chapters.filter((ch) => selectedChapterIds.includes(ch.chapter_id))
//       : chapters;
//     if (!chapsToUse.length) return [];
//     const chapList = chapsToUse.map((ch) => ({
//       chapter_id: ch.chapter_id,
//       topics: getTopicsForChapter(ch.chapter_id),
//     }));
//     // Only send if at least one chapter has topics
//     if (!chapList.some((c) => c.topics.length > 0)) return [];
//     return [{ ques_types: [{ ques_type_id: 1, chapters: chapList }] }];
//   }, [selectedSubjectId, selectedChapterIds, selectedTopicIds, chapters, topicsByChapter, allTopicsLoaded, getTopicsForChapter]);

//   const memoizedTags    = useMemo(() => selectedTags, [JSON.stringify(selectedTags)]);
//   const memoizedFilters = useMemo(() => filters,      [JSON.stringify(filters)]);

//   // ── APIs ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!accessToken) return;
//     fetch(Endpoints.PRISM_GET_COURSES, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json()).then((d) => setCourses(Array.isArray(d) ? d : d?.data || []));
//   }, [accessToken]);

//   useEffect(() => {
//     setSubjects([]); setSelectedSubjectId(""); setChapters([]);
//     setSelectedChapterIds([]); setSelectedTopicIds([]); setTopicsByChapter({}); setAllTopicsLoaded(false);
//     if (!selectedCourseId || !accessToken) return;
//     fetch(`${Endpoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json()).then((d) => setSubjects(Array.isArray(d) ? d : d?.data || []));
//   }, [selectedCourseId]);

//   // When subject changes: fetch all chapters, then auto-select all
//   useEffect(() => {
//     setChapters([]); setSelectedChapterIds([]); setSelectedTopicIds([]);
//     setTopicsByChapter({}); setAllTopicsLoaded(false);
//     if (!selectedSubjectId || !accessToken) return;
//     fetch(`${Endpoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json())
//       .then((d) => {
//         const list = Array.isArray(d) ? d : d?.data || [];
//         setChapters(list);
//         // Auto-select all chapters
//         setSelectedChapterIds(list.map((ch) => ch.chapter_id));
//       });
//   }, [selectedSubjectId]);

//   // When chapters load: fetch topics for every chapter in parallel, then auto-select all topics
//   useEffect(() => {
//     if (!chapters.length || !accessToken) {
//       setTopicsByChapter({}); setAllTopicsLoaded(false); return;
//     }
//     setAllTopicsLoaded(false);
//     let completed = 0;
//     const result = {};
//     const nameMap = {};
//     chapters.forEach((ch) => {
//       fetch(`${Endpoints.PRISM_GET_TOPICS_BY_CHAPTER}?chapter_id=${ch.chapter_id}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       })
//         .then((r) => r.json())
//         .then((data) => {
//           const topicList = Array.isArray(data) ? data : data?.data || [];
//           result[ch.chapter_id] = topicList.map((t) => t.topic_id);
//           topicList.forEach((t) => { nameMap[t.topic_id] = t.topic_name; });
//           completed++;
//           if (completed === chapters.length) {
//             setTopicsByChapter({ ...result });
//             setTopicNameMap({ ...nameMap });
//             // Auto-select ALL topics across all chapters
//             setSelectedTopicIds(Object.values(result).flat());
//             setAllTopicsLoaded(true);
//           }
//         })
//         .catch(() => {
//           completed++;
//           if (completed === chapters.length) {
//             setTopicsByChapter({ ...result });
//             setTopicNameMap({ ...nameMap });
//             setAllTopicsLoaded(true);
//           }
//         });
//     });
//   }, [chapters]);

//   useEffect(() => {
//     if (!accessToken) return;
//     fetch(Endpoints.PRISM_GET_PARSE_TAGS_ALL, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json()).then((d) => { if (d.data) setTags(d.data); });
//   }, [accessToken]);

//   // ── Tag handlers ─────────────────────────────────────────────────────────
//   const handleDropdownChange = (tag, opt) =>
//     setSelectedTags((prev) => {
//       const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
//       return opt?.id != null ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: opt.id }] : f;
//     });

//   const handleCheckboxChange = (tag, checked) =>
//     setSelectedTags((prev) => {
//       const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
//       return checked ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: 1 }] : f;
//     });


//   // ── Save ─────────────────────────────────────────────────────────────────
//   const proceedToSave = async () => {
//     // Build schedule_data from sectionWiseQuestions
//     // sectionWiseQuestions: { "2026-05-20": [{ id, text }, ...], ... }
//     const scheduleData = [];
//     Object.entries(sectionWiseQuestions).forEach(([scheduledDate, questions]) => {
//       questions.forEach((q) => {
//         scheduleData.push({
//           scheduled_date: scheduledDate,
//           parse_ques_set_question_id: q.id,
//           course_id: selectedCourseId ? parseInt(selectedCourseId) : 0,
//         });
//       });
//     });

//     if (scheduleData.length === 0) {
//       setActiveImg(ErrorIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>No questions assigned to any date. Please select questions and assign them to dates.</span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     // Show loading
//     setActiveImg(InfoIcon);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Saving MCQ schedule...</span>
//         </div>
//       </div>
//     );
//     setIsMessageBoxVisible(true);

//     try {
//       const res = await fetch(Endpoints.PRISM_CREATE_MCQ_SCHEDULE, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({
//           user_name: userName,
//           schedule_data: scheduleData,
//         }),
//       });
//       const data = await res.json();

//       if (data.status === 200) {
//         setActiveImg(InfoIcon);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{data.message || "MCQ schedule saved successfully!"}</span>
//             </div>
//             <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={() => { setIsMessageBoxVisible(false); navigate("/mcq_dashboard"); }}
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//       } else {
//         throw new Error(data.message || "Failed to save MCQ schedule");
//       }
//     } catch (err) {
//       console.error("MCQ save error:", err);
//       setActiveImg(ErrorIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Failed to save MCQ schedule. Please try again. {err.message}</span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleSave = () => {
//     if (!dateRangeComplete) {
//       setActiveImg(WarnningIcon);
//       setMessageBox(<div><p>Please complete the date range settings first.</p></div>);
//       setIsMessageBoxVisible(true); return;
//     }
//     if (!selectedSubjectId) {
//       setActiveImg(ErrorIcon);
//       setMessageBox(<div><p>Please select a subject before saving.</p></div>);
//       setIsMessageBoxVisible(true); return;
//     }
//     if (showUnderWarning) {
//       setNoTimeSet?.(true);
//       setActiveImg(WarnningIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Only {selectedCount} of {totalSlotsRequired} required questions selected. Some dates will have fewer questions. Save anyway?</span>
//           </div>
//           <div className="messagebox-insider2" style={{ display: "flex", gap: 10, marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>CANCEL</button>
//             <button className="messagebox-cancel-btn-ok" onClick={() => {
//               setIsMessageBoxVisible(false);
//               proceedToSave();
//             }}>SAVE ANYWAY</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true); return;
//     }
//     proceedToSave();
//   };

//   // ─────────────────────────────────────────────────────────────────────────
//   return (
//     <div className="create-role-container">

//       {/* Top bar */}
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">MCQ of the Day</span>
//         <div className="create-test-section-btns-container-ques-paper-dels">
//           <button className="create-test-section-btn-ques-paper-del" onClick={() => navigate('/mcq_of_day_dashboard')}>CANCEL</button>
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             style={{ marginRight: 0, boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={handleSave}
//             onMouseEnter={(e) => { e.target.style.backgroundColor = "#fa4741"; e.target.style.color = "white"; }}
//             onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; }}
//           >SAVE</button>
//         </div>
//       </div>

//       {/* ── SECTION 1: Date Range & Frequency ─────────────────────────── */}
//       <div className="display-ques-paper-del" style={{ marginTop: 20 }}>
//         <div className="personal-header">
//           <div className="header"><label>DATE RANGE &amp; FREQUENCY</label></div>
//           <div className="accordion-btn" onClick={() => setIsOpenDateRange((o) => !o)}>
//             {isOpenDateRange ? <div className="minus" /> : <div className="plus">+</div>}
//           </div>
//         </div>
//         {isOpenDateRange && (
//           <div className="accordion-content">
//             {/* 3 per row: From | To | Frequency  then  Num Questions alone */}
//             <div className="motd-grid-3">
//               <div className="motd-date-field">
//                 <label className="motd-label">From</label>
//                 <input type="date" className="motd-date-input" value={fromDate} max={toDate || undefined}
//                   onChange={(e) => setFromDate(e.target.value)} />
//               </div>
//               <div className="motd-date-field">
//                 <label className="motd-label">To</label>
//                 <input type="date" className="motd-date-input" value={toDate} min={fromDate || undefined}
//                   onChange={(e) => setToDate(e.target.value)} />
//               </div>
//               <div className="motd-date-field">
//                 <SectionSelectedDropdown label="Frequency" selected={frequency} setSelected={setFrequency}
//                   options={FREQUENCY_OPTIONS} Height="auto" OverFlow="auto" minheight="200px" />
//               </div>
//               <div className="motd-date-field">
//                 <SectionSelectedDropdown label="Questions per Day (max 3)" selected={numQuestions} setSelected={setNumQuestions}
//                   options={NUM_QUES_OPTIONS} Height="auto" OverFlow="auto" minheight="120px" />
//               </div>
//             </div>

//             {/* {dateRangeComplete && (
//               <div className="motd-summary-row">
//                 <span className="motd-summary-chip">📅 {dateList.length} date{dateList.length !== 1 ? "s" : ""}</span>
//                 <span className="motd-summary-chip">❓ {totalSlotsRequired} questions needed</span>
//                 {selectedCount > 0 && (
//                   <span className={`motd-summary-chip ${showUnderWarning ? "motd-warn" : showOverWarning ? "motd-over" : "motd-ok"}`}>
//                     ✓ {selectedCount} selected
//                     {showUnderWarning && ` — need ${totalSlotsRequired - selectedCount} more`}
//                     {showOverWarning  && ` — ${selectedCount - totalSlotsRequired} over limit`}
//                   </span>
//                 )}
//               </div>
//             )} */}
//             {/* {!dateRangeComplete && (
//               <div className="motd-hint-banner">ℹ Fill all four fields above to enable subject and tag selection.</div>
//             )} */}
//             {/* {showUnderWarning && (
//               <div className="motd-warning-banner">⚠ Fewer questions than slots — some dates will have fewer than {numQuestions} question(s).</div>
//             )} */}
//           </div>
//         )}
//       </div>

//       {/* ── SECTION 2: Subject & Tags Filter (merged) ─────────────────── */}
//       <div
//         className={`display-ques-paper-del motd-lockable${!dateRangeComplete ? " motd-locked" : ""}`}
//         style={{ marginTop: 20 }}
//       >
//         <div className="personal-header">
//           <div className="header">
//             <label>SUBJECT &amp; TAGS FILTER</label>
//             {/* {!dateRangeComplete && <span className="motd-lock-badge">🔒 Complete date range first</span>} */}
//           </div>
//           <div className="accordion-btn" onClick={() => dateRangeComplete && setIsOpenSubjectTags((o) => !o)}>
//             {isOpenSubjectTags ? <div className="minus" /> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenSubjectTags && (
//           <div className="accordion-content">
//             {/* Course/Subject/Chapter/Topic + type-1 tag dropdowns (PYQ, Assessment Type…) — all in same 3-col grid */}
//             <div className="motd-grid-3">
//               <SectionSelectedDropdown label="Course" selected={selectedCourseId}
//                 setSelected={(v) => { setSelectedCourseId(v); setSelectedSubjectId(""); setSelectedChapterIds([]); setSelectedTopicIds([]); setTopicsByChapter({}); setAllTopicsLoaded(false); }}
//                 options={courses.map((c) => ({ id: c.course_id, label: c.course_name }))}
//                 Height="auto" OverFlow="auto" minheight="300px" disabled={!dateRangeComplete} />
//               <SectionSelectedDropdown label="Subject" selected={selectedSubjectId}
//                 setSelected={(v) => { setSelectedSubjectId(v); setSelectedChapterIds([]); setSelectedTopicIds([]); }}
//                 options={subjects.map((s) => ({ id: s.subject_superset_id, label: s.subject_superset_name }))}
//                 Height="auto" OverFlow="auto" minheight="300px" disabled={!dateRangeComplete || !selectedCourseId} />
//               <MultiSelectSearchDropdown
//                 label="Chapter"
//                 selected={selectedChapterIds}
//                 setSelected={(ids) => {
//                   setSelectedChapterIds(ids);
//                   // When chapters change, reset topics to all topics for the newly selected chapters
//                   const allTopics = ids.flatMap((cid) => topicsByChapter[cid] || []);
//                   setSelectedTopicIds([...new Set(allTopics)]);
//                 }}
//                 options={chapters.map((ch) => ({ id: ch.chapter_id, label: ch.chapter_name }))}
//                 showSelectAll
//                 disabled={!dateRangeComplete || !selectedSubjectId}
//                 placeholder={allTopicsLoaded ? "" : "Loading…"}
//               />
//               <MultiSelectSearchDropdown
//                 label="Topic"
//                 selected={selectedTopicIds}
//                 setSelected={setSelectedTopicIds}
//                 options={
//                   (selectedChapterIds.length > 0 ? selectedChapterIds : chapters.map((ch) => ch.chapter_id))
//                     .flatMap((cid) => (topicsByChapter[cid] || []).map((tid) => ({
//                       id: tid,
//                       label: topicNameMap[tid] || String(tid),
//                     })))
//                     .filter((opt, idx, arr) => arr.findIndex((o) => o.id === opt.id) === idx) // dedupe
//                 }
//                 showSelectAll
//                 disabled={!dateRangeComplete || !selectedSubjectId}
//                 placeholder={allTopicsLoaded ? "" : "Loading…"}
//               />
//               {tags.filter((tag) => tag.parse_tag_type === 1 && tag.parse_tag_id !== 8).map((tag) => (
//                 <div key={tag.parse_tag_id}>
//                   <DropDownFilterTags
//                     label={tag.parse_tag_name}
//                     setSelected={(opt) => handleDropdownChange(tag, opt)}
//                     options={tag.parse_tag_value.map((v) => ({ label: v.tag_value, id: v.parse_tag_value_id }))}
//                     selected={selectedTags.find((t) => t.tag_id === tag.parse_tag_id)?.tag_value_id || null}
//                     disabled={!dateRangeComplete}
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Divider */}
//             <div className="motd-section-divider" />

//             {/* type-2 checkboxes — separate below */}
//             <div className="display-test-data-container-ques-paper-del-filter-tags">
//               <div className="display-grid-container-ques-paper-del-filter-tags">
//                 {tags.filter((tag) => tag.parse_tag_type === 2).map((tag) => (
//                   <div className="grid-item" key={tag.parse_tag_id}>
//                     <div className="check-box-tag-impt">
//                       <input type="checkbox" id={`motd-chk-${tag.parse_tag_id}`} className="cr-custom-checkbox-tags"
//                         onChange={(e) => handleCheckboxChange(tag, e.target.checked)}
//                         checked={selectedTags.some((t) => t.tag_id === tag.parse_tag_id && t.tag_value_id === 1)}
//                         disabled={!dateRangeComplete} />
//                       <label htmlFor={`motd-chk-${tag.parse_tag_id}`}>{tag.parse_tag_name}</label>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── SECTION 3: Questions List ──────────────────────────────────── */}
//       <div className="create-ques-paper-ques-list-container-text" style={{ marginTop: 20 }}>
//         <span>QUESTIONS LIST</span>
//       </div>
//       <div className="create-ques-paper-ques-list-container">
//         <TableDetailsQuesList
//           selectedTags={memoizedTags} filters={memoizedFilters}
//           setMessageBox={setMessageBox} messageBox={messageBox}
//           setIsMessageBoxVisible={setIsMessageBoxVisible} setActiveImg={setActiveImg}
//           setNoTimeSet={setNoTimeSet} dataClient={null}
//           setSelectedQuestions={setSelectedQuestions} setSelectedHeaders={setSelectedHeaders}
//           setDifficultyCount={setDifficultyCount} userId={userId}
//           showFlagModal={showFlagModal} setShowFlagModal={setShowFlagModal}
//           subjectId={selectedSubjectId ? parseInt(selectedSubjectId) : null}
//           courseId={selectedCourseId  ? parseInt(selectedCourseId)  : null}
//           scopeRefIds={[0]} setReportDashboardData={setReportDashboardData}
//           reportDashboardData={reportDashboardData} draftData={null}
//           selectedRows={selectedRows} setSelectedRows={setSelectedRows}
//           selectedQuestions={selectedQuestions} activeSubjectId={activeSubjectKey}
//           setVersion={handleVersionChange} excludeRepeatCount={0} clientBranchId={clientBranchId}
//           scopeId={0} loadingTab={false} setLoadingTab={() => {}} isReadOnly={false}
//         />
//       </div>

//       {/* ── SECTION 4: Selected Questions ─────────────────────────────── */}
//       <div className="create-ques-paper-ques-selected-container-text" style={{ marginTop: 20 }}>
//         <span>SELECTED QUESTIONS</span>
//       </div>
//       <div className="create-ques-paper-ques-selected-container">
//         <TableDetailsSelectedQues
//           selectedQuestions={selectedQuestions} selectedHeaders={selectedHeaders}
//           selectedSections={1}
//           setSectionWiseQuestions={setSectionWiseQuestions} selecteSectionTypeID={1}
//           setIsMessageBoxVisible={setIsMessageBoxVisible} setActiveImg={setActiveImg}
//           setMessageBox={setMessageBox} allQuesList={reportDashboardData}
//           setSelectedQuestions={setSelectedQuestions} selectedRows={selectedRows}
//           setSelectedRows={setSelectedRows} draftData={null} isReadOnlyMode={false}
//           setDifficultyCount={setDifficultyCount} activeSubjectId={activeSubjectKey}
//           version={version} setVersion={handleVersionChange} sectionWiseQuestions={sectionWiseQuestions}
//           customSectionOptions={customSectionOptions}
//           sectionColumnLabel="Schedule Date"
//           numQuestionsPerDate={numQuestions || 1}
//         />
//       </div>
//     </div>
//   );
// }
































// import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "./McqOfTheDay.css";
// import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
// import InfoIcon     from "../../../Assets/Images/CommanImages/Informative.png";
// import ErrorIcon    from "../../../Assets/Images/CommanImages/Error.png";
// import DropDownFilterTags      from "../QuestionPaperDetails/DropDownFilterTags";
// import SectionSelectedDropdown from "../QuestionPaperDetails/SectionSelectedDropdown";
// import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
// import TableDetailsQuesList    from "../QuestionPaperDetails/TableDetailsQuesList";
// import TableDetailsSelectedQues from "./TableDetailsSelectedQuestions";
// import Endpoints from "../../../Api/Endpoints";

// const FREQUENCY_OPTIONS = [
//   { id: "daily",     label: "Daily" },
//   { id: "alternate", label: "Alternate Days (Every 2 days)" },
//   { id: "every3",    label: "Once in 3 Days" },
//   { id: "every4",    label: "Once in 4 Days" },
//   { id: "weekly",    label: "Weekly" },
// ];
// const NUM_QUES_OPTIONS = [{ id: 1, label: "1" }, { id: 2, label: "2" }, { id: 3, label: "3" }];

// function buildDateList(from, to, freq) {
//   if (!from || !to || !freq) return [];
//   const start = new Date(from), end = new Date(to);
//   if (start > end) return [];
//   const step = freq === "daily" ? 1 : freq === "alternate" ? 2 : freq === "every3" ? 3 : freq === "every4" ? 4 : 7;
//   const dates = [];
//   for (let d = new Date(start); d <= end; d.setDate(d.getDate() + step))
//     dates.push(d.toISOString().split("T")[0]);
//   return dates;
// }

// // ── Returns minimum selectable FROM date based on server time ──────────────
// // - If server time is >= 6:00 AM → minimum is tomorrow
// // - If server time is < 6:00 AM  → minimum is today
// function getMinFromDate(serverCurrentTime) {
//   const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
//   const hours = base.getHours();
//   const result = new Date(base);
//   if (hours >= 6) {
//     result.setDate(result.getDate() + 1); // next day
//   }
//   // Return as YYYY-MM-DD
//   const year  = result.getFullYear();
//   const month = String(result.getMonth() + 1).padStart(2, "0");
//   const day   = String(result.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// }

// export default function McqOfTheDay({
//   dataClient, setMessageBox, messageBox,
//   setIsMessageBoxVisible, setActiveImg, setNoTimeSet,
// }) {
//   const navigate    = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userId         = dataClient?.client_schema_name?.[6]?.[0]?.user_id           || null;
//   const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name         || "";

//   // ── Server current time ──────────────────────────────────────────────────
//   const [serverCurrentTime, setServerCurrentTime] = useState(null);

//   useEffect(() => {
//     const fetchServerTime = async () => {
//       try {
//         const response = await fetch(
//           Endpoints.PRISM_GET_CURRENT_DATETIME,
//           { headers: { Authorization: `Bearer ${accessToken}` } }
//         );
//         const data = await response.json();
//         if (data?.status === 200 && data?.data) {
//           const { current_date, current_time } = data.data;
//           setServerCurrentTime(`${current_date}T${current_time}`);
//         }
//       } catch (error) {
//         console.error("Error fetching server time:", error);
//         setServerCurrentTime(new Date().toISOString()); // fallback to browser time
//       }
//     };
//     if (accessToken) fetchServerTime();
//   }, [accessToken]);

//   // ── Section 1: Date Range ────────────────────────────────────────────────
//   const [fromDate,     setFromDate]     = useState("");
//   const [toDate,       setToDate]       = useState("");
//   const [frequency,    setFrequency]    = useState("");
//   const [numQuestions, setNumQuestions] = useState("");
//   const [isOpenDateRange,    setIsOpenDateRange]    = useState(true);
//   const [isOpenSubjectTags,  setIsOpenSubjectTags]  = useState(true);

//   const dateRangeComplete = !!(fromDate && toDate && frequency && numQuestions);
//   const dateList = useMemo(() => buildDateList(fromDate, toDate, frequency), [fromDate, toDate, frequency]);
//   const totalSlotsRequired = dateList.length * (numQuestions || 0);
//   const customSectionOptions = useMemo(() => dateList.map((d) => ({ id: d, label: d })), [dateList]);

//   // ── Subject + Tags ───────────────────────────────────────────────────────
//   const [courses, setCourses]   = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [selectedCourseId,  setSelectedCourseId]  = useState("");
//   const [selectedSubjectId, setSelectedSubjectId] = useState("");
//   const [selectedChapterIds, setSelectedChapterIds] = useState([]); // array
//   const [selectedTopicIds,   setSelectedTopicIds]   = useState([]); // array
//   const [topicsByChapter,    setTopicsByChapter]    = useState({}); // { chapterId: [topicId,...] }
//   const [topicNameMap,       setTopicNameMap]       = useState({}); // { topicId: topicName }
//   const [allTopicsLoaded,    setAllTopicsLoaded]    = useState(false);
//   const [tags, setTags]           = useState([]);
//   const [selectedTags, setSelectedTags] = useState([]);

//   // ── Question list state ──────────────────────────────────────────────────
//   const [reportDashboardData,  setReportDashboardData]  = useState([]);
//   const [difficultyCount,      setDifficultyCount]      = useState({});
//   const [showFlagModal,        setShowFlagModal]        = useState(false);
//   const [version,              setVersion]              = useState(0);
//   const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});

//   // ── Per-subject selection maps ────────────────────────────────────────────
//   // Key: subjectId (or "mcqday"), Value: array of selected question objects
//   // This allows switching subjects while retaining each subject's selections
//   const [selectedQuestionsBySubject, setSelectedQuestionsBySubject] = useState({});
//   const [selectedRowsBySubject,      setSelectedRowsBySubject]      = useState({});
//   const [selectedHeadersBySubject,   setSelectedHeadersBySubject]   = useState({});

//   const activeSubjectKey = selectedSubjectId ? parseInt(selectedSubjectId) : "mcqday";

//   // Derive current subject's selected questions/rows from the maps
//   const selectedQuestions = selectedQuestionsBySubject[activeSubjectKey] || [];
//   const selectedRows      = selectedRowsBySubject[activeSubjectKey]      || [];
//   const selectedHeaders   = selectedHeadersBySubject[activeSubjectKey]   || [];

//   // Setters that update only the current subject's slice
//   const setSelectedQuestions = (questionsOrUpdater) => {
//     setSelectedQuestionsBySubject((prev) => ({
//       ...prev,
//       [activeSubjectKey]: typeof questionsOrUpdater === "function"
//         ? questionsOrUpdater(prev[activeSubjectKey] || [])
//         : questionsOrUpdater,
//     }));
//   };
//   const setSelectedRows = (rowsOrUpdater) => {
//     setSelectedRowsBySubject((prev) => ({
//       ...prev,
//       [activeSubjectKey]: typeof rowsOrUpdater === "function"
//         ? rowsOrUpdater(prev[activeSubjectKey] || [])
//         : rowsOrUpdater,
//     }));
//   };
//   const setSelectedHeaders = (headersOrUpdater) => {
//     setSelectedHeadersBySubject((prev) => ({
//       ...prev,
//       [activeSubjectKey]: typeof headersOrUpdater === "function"
//         ? headersOrUpdater(prev[activeSubjectKey] || [])
//         : headersOrUpdater,
//     }));
//   };

//   // ── Ref to track which subject's chapters are currently loading ───────────
//   // Prevents stale chapter IDs from a previous subject being used in filters
//   const filterSubjectRef = useRef(null);

//   // ── Clear all question selections (localStorage + React state) ───────────
//   const clearAllSelections = useCallback(() => {
//     localStorage.removeItem("subjectWiseSelectedRowIds");
//     localStorage.removeItem("subjectWiseDeletedRowIds");
//     localStorage.removeItem("mcqDateAssignments"); // ← also clear date assignments
//     // Reset all per-subject maps
//     setSelectedQuestionsBySubject({});
//     setSelectedRowsBySubject({});
//     setSelectedHeadersBySubject({});
//     setSectionWiseQuestions({});
//     setVersion((v) => v + 1);
//   }, []);

//   // Guarded version bump — blocks question selection when all slots are full
//   const handleVersionChange = useCallback((updater) => {
//     const newVersion = typeof updater === "function" ? updater(version) : updater;
//     const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     // Count TOTAL selections across ALL subjects for slot enforcement
//     const newCount = Object.values(selMap).reduce((sum, ids) => sum + (ids || []).length, 0);

//     // Only block if date range is configured AND total count exceeds total slots
//     if (dateRangeComplete && totalSlotsRequired > 0 && newCount > totalSlotsRequired) {
//       // Immediately remove the last added question
//       const key = String(activeSubjectKey);
//       const ids = selMap[key] || [];
//       const removedId = ids[ids.length - 1];
//       selMap[key] = ids.slice(0, -1);
//       localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));

//       // Also clean deleted map so re-select works cleanly
//       const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
//       delMap[key] = [...new Set([...(delMap[key] || []), removedId])];
//       localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

//       setActiveImg(WarnningIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>
//               ⚠ All {totalSlotsRequired} slot{totalSlotsRequired !== 1 ? "s" : ""} are filled
//               ({dateList.length} date{dateList.length !== 1 ? "s" : ""} × {numQuestions} per day).
//               Please deselect a question or expand the date range before adding more.
//             </span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//     }

//     setVersion(newVersion);
//   }, [version, activeSubjectKey, dateRangeComplete, totalSlotsRequired, dateList, numQuestions]);

//   // Live count from localStorage — TOTAL across ALL subjects
//   const [selectedCount, setSelectedCount] = useState(0);
//   useEffect(() => {
//     const m = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     // Sum selections across ALL subjects, not just the active one
//     const total = Object.values(m).reduce((sum, ids) => sum + (ids || []).length, 0);
//     setSelectedCount(total);
//   }, [version, activeSubjectKey]);

//   const showUnderWarning = dateRangeComplete && selectedCount > 0 && selectedCount < totalSlotsRequired;
//   const showOverWarning  = dateRangeComplete && selectedCount > totalSlotsRequired;

//   // ── Filters ──────────────────────────────────────────────────────────────
//   // Compute the topic IDs that should go into the filter for a given chapter:
//   // - If user has manually picked specific topics → use only those
//   // - Otherwise → use all topics for that chapter from topicsByChapter
//   const getTopicsForChapter = useCallback((chapterId) => {
//     const allForChapter = topicsByChapter[chapterId] || [];
//     if (selectedTopicIds.length === 0) return allForChapter;
//     return selectedTopicIds.filter((tid) => allForChapter.includes(tid));
//   }, [selectedTopicIds, topicsByChapter]);

//   const filters = useMemo(() => {
//     if (!selectedSubjectId || !allTopicsLoaded) return [];

//     // ── Stale chapter IDs guard ──────────────────────────────────────────────
//     // If selectedChapterIds belong to a previous subject (chapters state not
//     // yet updated), return empty and wait for both to sync before sending filter
//     if (selectedChapterIds.length > 0) {
//       const chapterIdSet = new Set(chapters.map((ch) => ch.chapter_id));
//       const allMatch = selectedChapterIds.every((id) => chapterIdSet.has(id));
//       if (!allMatch) return []; // stale — chapters and chapterIds out of sync
//     }

//     const chapsToUse = selectedChapterIds.length > 0
//       ? chapters.filter((ch) => selectedChapterIds.includes(ch.chapter_id))
//       : chapters;

//     if (!chapsToUse.length) return [];

//     const chapList = chapsToUse.map((ch) => ({
//       chapter_id: ch.chapter_id,
//       topics: getTopicsForChapter(ch.chapter_id), // empty array is fine
//     }));

//     // ── Removed: if (!chapList.some((c) => c.topics.length > 0)) return []; ──
//     // Chapters with no topics are valid — questions API should still be called

//     return [{ ques_types: [{ ques_type_id: 1, chapters: chapList }] }];
//   }, [selectedSubjectId, selectedChapterIds, selectedTopicIds, chapters, topicsByChapter, allTopicsLoaded, getTopicsForChapter]);

//   const memoizedTags    = useMemo(() => selectedTags, [JSON.stringify(selectedTags)]);
//   const memoizedFilters = useMemo(() => filters,      [JSON.stringify(filters)]);

//   // ── APIs ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!accessToken) return;
//     fetch(Endpoints.PRISM_GET_COURSES, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json()).then((d) => setCourses(Array.isArray(d) ? d : d?.data || []));
//   }, [accessToken]);

//   useEffect(() => {
//     setSubjects([]); setSelectedSubjectId(""); setChapters([]);
//     setSelectedChapterIds([]); setSelectedTopicIds([]); setTopicsByChapter({}); setAllTopicsLoaded(false);
//     if (!selectedCourseId || !accessToken) return;
//     fetch(`${Endpoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json()).then((d) => setSubjects(Array.isArray(d) ? d : d?.data || []));
//   }, [selectedCourseId]);

//   // When subject changes: fetch all chapters, then auto-select all
//   // NOTE: Questions per subject are retained via localStorage keyed by activeSubjectKey
//   useEffect(() => {
//     setChapters([]); setSelectedChapterIds([]); setSelectedTopicIds([]);
//     setTopicsByChapter({}); setAllTopicsLoaded(false);

//     // Stamp the ref so we can detect if subject changed again before fetch completes
//     filterSubjectRef.current = selectedSubjectId;

//     if (!selectedSubjectId || !accessToken) return;
//     fetch(`${Endpoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json())
//       .then((d) => {
//         // Guard: if subject changed again while this fetch was in flight, discard result
//         if (filterSubjectRef.current !== selectedSubjectId) return;
//         const list = Array.isArray(d) ? d : d?.data || [];
//         setChapters(list);
//         setSelectedChapterIds(list.map((ch) => ch.chapter_id));
//       });
//   }, [selectedSubjectId]);

//   // When chapters load: fetch topics for every chapter in parallel, then auto-select all topics
//   useEffect(() => {
//     if (!chapters.length || !accessToken) {
//       setTopicsByChapter({}); setAllTopicsLoaded(false); return;
//     }
//     setAllTopicsLoaded(false);
//     let completed = 0;
//     const result = {};
//     const nameMap = {};
//     chapters.forEach((ch) => {
//       fetch(`${Endpoints.PRISM_GET_TOPICS_BY_CHAPTER}?chapter_id=${ch.chapter_id}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       })
//         .then((r) => r.json())
//         .then((data) => {
//           const topicList = Array.isArray(data) ? data : data?.data || [];
//           result[ch.chapter_id] = topicList.map((t) => t.topic_id);
//           topicList.forEach((t) => { nameMap[t.topic_id] = t.topic_name; });
//           completed++;
//           if (completed === chapters.length) {
//             setTopicsByChapter({ ...result });
//             setTopicNameMap({ ...nameMap });
//             setSelectedTopicIds(Object.values(result).flat());
//             setAllTopicsLoaded(true);
//           }
//         })
//         .catch(() => {
//           completed++;
//           if (completed === chapters.length) {
//             setTopicsByChapter({ ...result });
//             setTopicNameMap({ ...nameMap });
//             setAllTopicsLoaded(true);
//           }
//         });
//     });
//   }, [chapters]);

//   useEffect(() => {
//     if (!accessToken) return;
//     fetch(Endpoints.PRISM_GET_PARSE_TAGS_ALL, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json()).then((d) => { if (d.data) setTags(d.data); });
//   }, [accessToken]);

//   // ── Tag handlers ─────────────────────────────────────────────────────────
//   const handleDropdownChange = (tag, opt) =>
//     setSelectedTags((prev) => {
//       const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
//       return opt?.id != null ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: opt.id }] : f;
//     });

//   const handleCheckboxChange = (tag, checked) =>
//     setSelectedTags((prev) => {
//       const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
//       return checked ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: 1 }] : f;
//     });

//   // ── Save ─────────────────────────────────────────────────────────────────
//   const proceedToSave = async () => {
//     const scheduleData = [];
//     Object.entries(sectionWiseQuestions).forEach(([scheduledDate, questions]) => {
//       questions.forEach((q) => {
//         scheduleData.push({
//           scheduled_date: scheduledDate,
//           parse_ques_set_question_id: q.id,
//           course_id: selectedCourseId ? parseInt(selectedCourseId) : 0,
//         });
//       });
//     });

//     if (scheduleData.length === 0) {
//       setActiveImg(ErrorIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>No questions assigned to any date. Please select questions and assign them to dates.</span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     setActiveImg(InfoIcon);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Saving MCQ schedule...</span>
//         </div>
//       </div>
//     );
//     setIsMessageBoxVisible(true);

//     try {
//       const res = await fetch(Endpoints.PRISM_CREATE_MCQ_SCHEDULE, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({
//           user_name: userName,
//           schedule_data: scheduleData,
//         }),
//       });
//       const data = await res.json();

//       if (data.status === 200) {
//         // ── Clear all MCQ localStorage on successful save ──────────────────
//         localStorage.removeItem("mcqDateAssignments");
//         localStorage.removeItem("subjectWiseSelectedRowIds");
//         localStorage.removeItem("subjectWiseDeletedRowIds");

//         setActiveImg(InfoIcon);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{data.message || "MCQ schedule saved successfully!"}</span>
//             </div>
//             <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={() => { setIsMessageBoxVisible(false); navigate("/mcq_dashboard"); }}
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//       } else {
//         throw new Error(data.message || "Failed to save MCQ schedule");
//       }
//     } catch (err) {
//       console.error("MCQ save error:", err);
//       setActiveImg(ErrorIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Failed to save MCQ schedule. Please try again. {err.message}</span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleSave = () => {
//     if (!dateRangeComplete) {
//       setActiveImg(WarnningIcon);
//       setMessageBox(<div><p>Please complete the date range settings first.</p></div>);
//       setIsMessageBoxVisible(true); return;
//     }
//     if (!selectedSubjectId) {
//       setActiveImg(ErrorIcon);
//       setMessageBox(<div><p>Please select a subject before saving.</p></div>);
//       setIsMessageBoxVisible(true); return;
//     }
//     if (showUnderWarning) {
//       setNoTimeSet?.(true);
//       setActiveImg(WarnningIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Only {selectedCount} of {totalSlotsRequired} required questions selected. Some dates will have fewer questions. Save anyway?</span>
//           </div>
//           <div className="messagebox-insider2" style={{ display: "flex", gap: 10, marginTop: 10 }}>
//             <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>CANCEL</button>
//             <button className="messagebox-cancel-btn-ok" onClick={() => {
//               setIsMessageBoxVisible(false);
//               proceedToSave();
//             }}>SAVE ANYWAY</button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true); return;
//     }
//     proceedToSave();
//   };

//   // ── All selected questions merged across ALL subjects ────────────────────
//   // Used in the SELECTED QUESTIONS table so it shows all subjects' selections.
//   // We merge per-subject maps so switching subjects doesn't clear the table.
//   const allSelectedQuestions = Object.values(selectedQuestionsBySubject).flat();
//   const allSelectedRows      = Object.values(selectedRowsBySubject).flat();

//   // ── Stable selected questions for the SELECTED table ─────────────────────
//   // Built from localStorage so it survives subject switches without waiting
//   // for the questions list to re-fetch and re-populate selectedQuestions state.
//   // We rebuild from mcqDateAssignments + subjectWiseSelectedRowIds.
//   const stableSelectedQuestions = useMemo(() => {
//     const assignments = JSON.parse(localStorage.getItem("mcqDateAssignments") || "{}");
//     const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     // Collect all selected question IDs across all subjects
//     const allIds = new Set(
//       Object.values(selMap).flat().map(String)
//     );
//     if (allIds.size === 0) return [];
//     // Build minimal row entries: [dateLabel, questionId, questionText, ...]
//     // Text from allSelectedQuestions if available, otherwise use ID as placeholder
//     return Array.from(allIds).map((qid) => {
//       const existingRow = allSelectedQuestions.find((r) => String(r[1]) === qid);
//       if (existingRow) return existingRow;
//       // Fallback row for questions from other subjects not currently in state
//       return ["", qid, qid, "", "", "", ""];
//     });
//   }, [version, allSelectedQuestions]);

//   // ── Computed min date for FROM input ──────────────────────────────────────
//   const minFromDate = getMinFromDate(serverCurrentTime);

//   // ─────────────────────────────────────────────────────────────────────────
//   return (
//     <div className="create-role-container">

//       {/* Top bar */}
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">MCQ of the Day</span>
//         <div className="create-test-section-btns-container-ques-paper-dels">
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             onClick={() => {
//               localStorage.removeItem("mcqDateAssignments");
//               localStorage.removeItem("subjectWiseSelectedRowIds");
//               localStorage.removeItem("subjectWiseDeletedRowIds");
//               navigate('/mcq_dashboard');
//             }}
//           >CANCEL</button>
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             style={{ marginRight: 0, boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={handleSave}
//             onMouseEnter={(e) => { e.target.style.backgroundColor = "#fa4741"; e.target.style.color = "white"; }}
//             onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; }}
//           >SAVE</button>
//         </div>
//       </div>

//       {/* ── SECTION 1: Date Range & Frequency ─────────────────────────── */}
//       <div className="display-ques-paper-del" style={{ marginTop: 20 }}>
//         <div className="personal-header">
//           <div className="header"><label>DATE RANGE &amp; FREQUENCY</label></div>
//           <div className="accordion-btn" onClick={() => setIsOpenDateRange((o) => !o)}>
//             {isOpenDateRange ? <div className="minus" /> : <div className="plus">+</div>}
//           </div>
//         </div>
//         {isOpenDateRange && (
//           <div className="accordion-content">
//             <div className="motd-grid-3">

//               {/* ── FROM DATE ── */}
//               <div className="motd-date-field">
//                 <label className="motd-label">From</label>
//                 <input
//                   type="date"
//                   className="motd-date-input"
//                   value={fromDate}
//                   min={minFromDate}
//                   max={toDate || undefined}
//                   onChange={(e) => {
//                     const newFrom = e.target.value;

//                     // Block dates before minimum (browser min attr handles UI,
//                     // this is a safety guard for manual input)
//                     if (newFrom < minFromDate) return;

//                     // If date range was previously complete, clear all selections
//                     // so user re-assigns questions to the new date range
//                     if (dateRangeComplete) {
//                       clearAllSelections();
//                     }

//                     setFromDate(newFrom);

//                     // If toDate is now before new fromDate, clear it
//                     if (toDate && newFrom > toDate) {
//                       setToDate("");
//                     }
//                   }}
//                 />
//               </div>

//               {/* ── TO DATE ── */}
//               <div className="motd-date-field">
//                 <label className="motd-label">To</label>
//                 <input
//                   type="date"
//                   className="motd-date-input"
//                   value={toDate}
//                   min={fromDate || minFromDate}
//                   onChange={(e) => {
//                     // If date range was previously complete, clear all selections
//                     if (dateRangeComplete) {
//                       clearAllSelections();
//                     }
//                     setToDate(e.target.value);
//                   }}
//                 />
//               </div>

//               {/* ── FREQUENCY ── */}
//               <div className="motd-date-field">
//                 <SectionSelectedDropdown
//                   label="Frequency"
//                   selected={frequency}
//                   setSelected={(val) => {
//                     // Clear selections when frequency changes as date slots change
//                     if (dateRangeComplete) {
//                       clearAllSelections();
//                     }
//                     setFrequency(val);
//                   }}
//                   options={FREQUENCY_OPTIONS}
//                   Height="auto" OverFlow="auto" minheight="200px"
//                 />
//               </div>

//               {/* ── QUESTIONS PER DAY ── */}
//               <div className="motd-date-field">
//                 <SectionSelectedDropdown
//                   label="Questions per Day (max 3)"
//                   selected={numQuestions}
//                   setSelected={(val) => {
//                     // Clear selections when questions per day changes as slot count changes
//                     if (dateRangeComplete) {
//                       clearAllSelections();
//                     }
//                     setNumQuestions(val);
//                   }}
//                   options={NUM_QUES_OPTIONS}
//                   Height="auto" OverFlow="auto" minheight="120px"
//                 />
//               </div>

//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── SECTION 2: Subject & Tags Filter (merged) ─────────────────── */}
//       <div
//         className={`display-ques-paper-del motd-lockable${!dateRangeComplete ? " motd-locked" : ""}`}
//         style={{ marginTop: 20 }}
//       >
//         <div className="personal-header">
//           <div className="header">
//             <label>SUBJECT &amp; TAGS FILTER</label>
//           </div>
//           <div className="accordion-btn" onClick={() => dateRangeComplete && setIsOpenSubjectTags((o) => !o)}>
//             {isOpenSubjectTags ? <div className="minus" /> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenSubjectTags && (
//           <div className="accordion-content">
//             <div className="motd-grid-3">
//               <SectionSelectedDropdown
//                 label="Course"
//                 selected={selectedCourseId}
//                 setSelected={(v) => {
//                   setSelectedCourseId(v);
//                   setSelectedSubjectId("");
//                   setSelectedChapterIds([]);
//                   setSelectedTopicIds([]);
//                   setTopicsByChapter({});
//                   setAllTopicsLoaded(false);
//                 }}
//                 options={courses.map((c) => ({ id: c.course_id, label: c.course_name }))}
//                 Height="auto" OverFlow="auto" minheight="300px"
//                 disabled={!dateRangeComplete}
//               />
//               <SectionSelectedDropdown
//                 label="Subject"
//                 selected={selectedSubjectId}
//                 setSelected={(v) => {
//                   // Subject switch retains previous subject's questions via
//                   // localStorage key (activeSubjectKey = selectedSubjectId)
//                   setSelectedSubjectId(v);
//                   setSelectedChapterIds([]);
//                   setSelectedTopicIds([]);
//                 }}
//                 options={subjects.map((s) => ({ id: s.subject_superset_id, label: s.subject_superset_name }))}
//                 Height="auto" OverFlow="auto" minheight="300px"
//                 disabled={!dateRangeComplete || !selectedCourseId}
//               />
//               <MultiSelectSearchDropdown
//                 label="Chapter"
//                 selected={selectedChapterIds}
//                 setSelected={(ids) => {
//                   setSelectedChapterIds(ids);
//                   const allTopics = ids.flatMap((cid) => topicsByChapter[cid] || []);
//                   setSelectedTopicIds([...new Set(allTopics)]);
//                 }}
//                 options={chapters.map((ch) => ({ id: ch.chapter_id, label: ch.chapter_name }))}
//                 showSelectAll
//                 disabled={!dateRangeComplete || !selectedSubjectId}
//                 placeholder={allTopicsLoaded ? "" : "Loading…"}
//               />
//               <MultiSelectSearchDropdown
//                 label="Topic"
//                 selected={selectedTopicIds}
//                 setSelected={setSelectedTopicIds}
//                 options={
//                   (selectedChapterIds.length > 0 ? selectedChapterIds : chapters.map((ch) => ch.chapter_id))
//                     .flatMap((cid) => (topicsByChapter[cid] || []).map((tid) => ({
//                       id: tid,
//                       label: topicNameMap[tid] || String(tid),
//                     })))
//                     .filter((opt, idx, arr) => arr.findIndex((o) => o.id === opt.id) === idx)
//                 }
//                 showSelectAll
//                 disabled={!dateRangeComplete || !selectedSubjectId}
//                 placeholder={allTopicsLoaded ? "" : "Loading…"}
//               />
//               {tags.filter((tag) => tag.parse_tag_type === 1 && tag.parse_tag_id !== 8).map((tag) => (
//                 <div key={tag.parse_tag_id}>
//                   <DropDownFilterTags
//                     label={tag.parse_tag_name}
//                     setSelected={(opt) => handleDropdownChange(tag, opt)}
//                     options={tag.parse_tag_value.map((v) => ({ label: v.tag_value, id: v.parse_tag_value_id }))}
//                     selected={selectedTags.find((t) => t.tag_id === tag.parse_tag_id)?.tag_value_id || null}
//                     disabled={!dateRangeComplete}
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Divider */}
//             <div className="motd-section-divider" />

//             {/* type-2 checkboxes */}
//             <div className="display-test-data-container-ques-paper-del-filter-tags">
//               <div className="display-grid-container-ques-paper-del-filter-tags">
//                 {tags.filter((tag) => tag.parse_tag_type === 2).map((tag) => (
//                   <div className="grid-item" key={tag.parse_tag_id}>
//                     <div className="check-box-tag-impt">
//                       <input
//                         type="checkbox"
//                         id={`motd-chk-${tag.parse_tag_id}`}
//                         className="cr-custom-checkbox-tags"
//                         onChange={(e) => handleCheckboxChange(tag, e.target.checked)}
//                         checked={selectedTags.some((t) => t.tag_id === tag.parse_tag_id && t.tag_value_id === 1)}
//                         disabled={!dateRangeComplete}
//                       />
//                       <label htmlFor={`motd-chk-${tag.parse_tag_id}`}>{tag.parse_tag_name}</label>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── SECTION 3: Questions List ──────────────────────────────────── */}
//       <div className="create-ques-paper-ques-list-container-text" style={{ marginTop: 20 }}>
//         <span>QUESTIONS LIST</span>
//       </div>
//       <div className="create-ques-paper-ques-list-container">
//         <TableDetailsQuesList
//           selectedTags={memoizedTags} filters={memoizedFilters}
//           setMessageBox={setMessageBox} messageBox={messageBox}
//           setIsMessageBoxVisible={setIsMessageBoxVisible} setActiveImg={setActiveImg}
//           setNoTimeSet={setNoTimeSet} dataClient={null}
//           setSelectedQuestions={setSelectedQuestions} setSelectedHeaders={setSelectedHeaders}
//           setDifficultyCount={setDifficultyCount} userId={userId}
//           showFlagModal={showFlagModal} setShowFlagModal={setShowFlagModal}
//           subjectId={selectedSubjectId ? parseInt(selectedSubjectId) : null}
//           courseId={selectedCourseId  ? parseInt(selectedCourseId)  : null}
//           scopeRefIds={[0]} setReportDashboardData={setReportDashboardData}
//           reportDashboardData={reportDashboardData} draftData={null}
//           selectedRows={selectedRows} setSelectedRows={setSelectedRows}
//           selectedQuestions={selectedQuestions} activeSubjectId={activeSubjectKey}
//           setVersion={handleVersionChange} excludeRepeatCount={0} clientBranchId={clientBranchId}
//           scopeId={0} loadingTab={false} setLoadingTab={() => {}} isReadOnly={false}
//         />
//       </div>

//       {/* ── SECTION 4: Selected Questions ─────────────────────────────── */}
//       <div className="create-ques-paper-ques-selected-container-text" style={{ marginTop: 20 }}>
//         <span>SELECTED QUESTIONS</span>
//       </div>
//       <div className="create-ques-paper-ques-selected-container">
//         <TableDetailsSelectedQues
//           selectedQuestions={stableSelectedQuestions} selectedHeaders={selectedHeaders}
//           selectedSections={1}
//           setSectionWiseQuestions={setSectionWiseQuestions} selecteSectionTypeID={1}
//           setIsMessageBoxVisible={setIsMessageBoxVisible} setActiveImg={setActiveImg}
//           setMessageBox={setMessageBox} allQuesList={reportDashboardData}
//           setSelectedQuestions={setSelectedQuestions} selectedRows={allSelectedRows}
//           setSelectedRows={setSelectedRows} draftData={null} isReadOnlyMode={false}
//           setDifficultyCount={setDifficultyCount} activeSubjectId={activeSubjectKey}
//           version={version} setVersion={handleVersionChange}
//           sectionWiseQuestions={sectionWiseQuestions}
//           customSectionOptions={customSectionOptions}
//           sectionColumnLabel="Schedule Date"
//           numQuestionsPerDate={numQuestions || 1}
//         />
//       </div>
//     </div>
//   );
// }





























import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./McqOfTheDay.css";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import InfoIcon     from "../../../Assets/Images/CommanImages/Informative.png";
import ErrorIcon    from "../../../Assets/Images/CommanImages/Error.png";
import DropDownFilterTags      from "../QuestionPaperDetails/DropDownFilterTags";
import SectionSelectedDropdown from "../QuestionPaperDetails/SectionSelectedDropdown";
import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
import TableDetailsQuesList    from "../QuestionPaperDetails/TableDetailsQuesList";
import TableDetailsSelectedQues from "./TableDetailsSelectedQuestions";
import Endpoints from "../../../Api/Endpoints";

const FREQUENCY_OPTIONS = [
  { id: "daily",     label: "Daily" },
  { id: "alternate", label: "Alternate Days (Every 2 days)" },
  { id: "every3",    label: "Once in 3 Days" },
  { id: "every4",    label: "Once in 4 Days" },
  { id: "weekly",    label: "Weekly" },
];
const NUM_QUES_OPTIONS = [{ id: 1, label: "1" }, { id: 2, label: "2" }, { id: 3, label: "3" }];

function buildDateList(from, to, freq) {
  if (!from || !to || !freq) return [];
  const start = new Date(from), end = new Date(to);
  if (start > end) return [];
  const step = freq === "daily" ? 1 : freq === "alternate" ? 2 : freq === "every3" ? 3 : freq === "every4" ? 4 : 7;
  const dates = [];
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + step))
    dates.push(d.toISOString().split("T")[0]);
  return dates;
}

// ── Returns minimum selectable FROM date based on server time ──────────────
// - If server time is >= 6:00 AM → minimum is tomorrow
// - If server time is < 6:00 AM  → minimum is today
function getMinFromDate(serverCurrentTime) {
  const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
  const hours = base.getHours();
  const result = new Date(base);
  if (hours >= 6) {
    result.setDate(result.getDate() + 1); // next day
  }
  // Return as YYYY-MM-DD
  const year  = result.getFullYear();
  const month = String(result.getMonth() + 1).padStart(2, "0");
  const day   = String(result.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function McqOfTheDay({
  dataClient, setMessageBox, messageBox,
  setIsMessageBoxVisible, setActiveImg, setNoTimeSet,
}) {
  const navigate    = useNavigate();
  const accessToken = localStorage.getItem("other");
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userId         = dataClient?.client_schema_name?.[6]?.[0]?.user_id           || null;
  const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name         || "";

  // ── Clear stale localStorage on fresh page load ──────────────────────────
  // mcqDateAssignments persists across page refreshes which causes auto-assign
  // to skip questions that were assigned in a previous session.
  // We clear it on mount so every new session starts clean.
  useEffect(() => {
    localStorage.removeItem("mcqDateAssignments");
    localStorage.removeItem("subjectWiseSelectedRowIds");
    localStorage.removeItem("subjectWiseDeletedRowIds");
    localStorage.removeItem("mcqRowDataStore");
  }, []); // runs once on mount only

  // ── Server current time ──────────────────────────────────────────────────
  const [serverCurrentTime, setServerCurrentTime] = useState(null);

  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const response = await fetch(
          Endpoints.PRISM_GET_CURRENT_DATETIME,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        const data = await response.json();
        if (data?.status === 200 && data?.data) {
          const { current_date, current_time } = data.data;
          setServerCurrentTime(`${current_date}T${current_time}`);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        setServerCurrentTime(new Date().toISOString()); // fallback to browser time
      }
    };
    if (accessToken) fetchServerTime();
  }, [accessToken]);

  // ── Section 1: Date Range ────────────────────────────────────────────────
  const [fromDate,     setFromDate]     = useState("");
  const [toDate,       setToDate]       = useState("");
  const [frequency,    setFrequency]    = useState("");
  const [numQuestions, setNumQuestions] = useState("");
  const [isOpenDateRange,    setIsOpenDateRange]    = useState(true);
  const [isOpenSubjectTags,  setIsOpenSubjectTags]  = useState(true);

  const dateRangeComplete = !!(fromDate && toDate && frequency && numQuestions);
  const dateList = useMemo(() => buildDateList(fromDate, toDate, frequency), [fromDate, toDate, frequency]);
  const totalSlotsRequired = dateList.length * (numQuestions || 0);
  const customSectionOptions = useMemo(() => dateList.map((d) => ({ id: d, label: d })), [dateList]);

  // ── Subject + Tags ───────────────────────────────────────────────────────
  const [courses, setCourses]   = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [selectedCourseId,  setSelectedCourseId]  = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedChapterIds, setSelectedChapterIds] = useState([]); // array
  const [selectedTopicIds,   setSelectedTopicIds]   = useState([]); // array
  const [topicsByChapter,    setTopicsByChapter]    = useState({}); // { chapterId: [topicId,...] }
  const [topicNameMap,       setTopicNameMap]       = useState({}); // { topicId: topicName }
  const [allTopicsLoaded,    setAllTopicsLoaded]    = useState(false);
  const [tags, setTags]           = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  // ── Question list state ──────────────────────────────────────────────────
  const [reportDashboardData,  setReportDashboardData]  = useState([]);
  const [difficultyCount,      setDifficultyCount]      = useState({});
  const [showFlagModal,        setShowFlagModal]        = useState(false);
  const [version,              setVersion]              = useState(0);
  const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});

  // ── Per-subject selection maps ────────────────────────────────────────────
  // Key: subjectId (or "mcqday"), Value: array of selected question objects
  // This allows switching subjects while retaining each subject's selections
  const [selectedQuestionsBySubject, setSelectedQuestionsBySubject] = useState({});
  const [selectedRowsBySubject,      setSelectedRowsBySubject]      = useState({});
  const [selectedHeadersBySubject,   setSelectedHeadersBySubject]   = useState({});

  // ── Persistent row data store ────────────────────────────────────────────
  // mcqRowDataStore in localStorage: { questionId: serializedRow }
  // Stores full row data for every selected question across all subjects.
  // Written whenever reportDashboardData loads — for every row whose ID
  // is in subjectWiseSelectedRowIds. This survives subject switches because
  // localStorage persists, unlike React state which is per-render.
  const STORE_KEY = "mcqRowDataStore";

  const activeSubjectKey = selectedSubjectId ? parseInt(selectedSubjectId) : "mcqday";

  // Whenever question list loads, cache selected rows to localStorage.
  // reportDashboardData rows: [questionId, col1, col2, ...] — row[0] is the ID
  // (confirmed from TableDetailsQuesList: uniqueMap[row[0]] and handleRowSelect(row[0]))
  useEffect(() => {
    if (!reportDashboardData?.length) return;
    const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    const allSelectedIds = new Set(Object.values(selMap).flat().map(String));
    if (allSelectedIds.size === 0) return;

    const store = JSON.parse(localStorage.getItem(STORE_KEY) || "{}");
    let changed = false;
    reportDashboardData.forEach((row) => {
      const qid = String(row[0]); // row[0] is Question ID in TableDetailsQuesList format
      if (allSelectedIds.has(qid) && !store[qid]) {
        try {
          // Store serialized row — primitives only
          store[qid] = JSON.stringify(
            row.map((cell) => (typeof cell === "object" ? String(cell) : cell))
          );
          changed = true;
        } catch (_) {}
      }
    });
    if (changed) {
      localStorage.setItem(STORE_KEY, JSON.stringify(store));
      setVersion((v) => v + 1);
    }
  }, [reportDashboardData]);

  // Derive current subject's selected questions/rows from the maps
  const selectedQuestions = selectedQuestionsBySubject[activeSubjectKey] || [];
  const selectedRows      = selectedRowsBySubject[activeSubjectKey]      || [];
  const selectedHeaders   = selectedHeadersBySubject[activeSubjectKey]   || [];

  // Setters that update only the current subject's slice
  const setSelectedQuestions = (questionsOrUpdater) => {
    setSelectedQuestionsBySubject((prev) => ({
      ...prev,
      [activeSubjectKey]: typeof questionsOrUpdater === "function"
        ? questionsOrUpdater(prev[activeSubjectKey] || [])
        : questionsOrUpdater,
    }));
  };
  const setSelectedRows = (rowsOrUpdater) => {
    setSelectedRowsBySubject((prev) => ({
      ...prev,
      [activeSubjectKey]: typeof rowsOrUpdater === "function"
        ? rowsOrUpdater(prev[activeSubjectKey] || [])
        : rowsOrUpdater,
    }));
  };
  const setSelectedHeaders = (headersOrUpdater) => {
    setSelectedHeadersBySubject((prev) => ({
      ...prev,
      [activeSubjectKey]: typeof headersOrUpdater === "function"
        ? headersOrUpdater(prev[activeSubjectKey] || [])
        : headersOrUpdater,
    }));
  };

  // ── Ref to track which subject's chapters are currently loading ───────────
  // Prevents stale chapter IDs from a previous subject being used in filters
  const filterSubjectRef = useRef(null);

  // ── Clear all question selections (localStorage + React state) ───────────
  const clearAllSelections = useCallback(() => {
    localStorage.removeItem("subjectWiseSelectedRowIds");
    localStorage.removeItem("subjectWiseDeletedRowIds");
    localStorage.removeItem("mcqDateAssignments");
    localStorage.removeItem("mcqRowDataStore");
    // Reset all per-subject maps
    setSelectedQuestionsBySubject({});
    setSelectedRowsBySubject({});
    setSelectedHeadersBySubject({});
    setSectionWiseQuestions({});
    setVersion((v) => v + 1);
  }, []);

  // Guarded version bump — blocks question selection when all slots are full
  const handleVersionChange = useCallback((updater) => {
    const newVersion = typeof updater === "function" ? updater(version) : updater;
    const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    // Count TOTAL selections across ALL subjects for slot enforcement
    const newCount = Object.values(selMap).reduce((sum, ids) => sum + (ids || []).length, 0);

    // Only block if date range is configured AND total count exceeds total slots
    if (dateRangeComplete && totalSlotsRequired > 0 && newCount > totalSlotsRequired) {
      // Immediately remove the last added question
      const key = String(activeSubjectKey);
      const ids = selMap[key] || [];
      const removedId = ids[ids.length - 1];
      selMap[key] = ids.slice(0, -1);
      localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));

      // Also clean deleted map so re-select works cleanly
      const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
      delMap[key] = [...new Set([...(delMap[key] || []), removedId])];
      localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

      setActiveImg(WarnningIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>
              ⚠ All {totalSlotsRequired} slot{totalSlotsRequired !== 1 ? "s" : ""} are filled
              ({dateList.length} date{dateList.length !== 1 ? "s" : ""} × {numQuestions} per day).
              Please deselect a question or expand the date range before adding more.
            </span>
          </div>
          <div className="messagebox-insider2" style={{ marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
    }

    setVersion(newVersion);
  }, [version, activeSubjectKey, dateRangeComplete, totalSlotsRequired, dateList, numQuestions]);

  // Live count from localStorage — TOTAL across ALL subjects
  const [selectedCount, setSelectedCount] = useState(0);
  useEffect(() => {
    const m = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    // Sum selections across ALL subjects, not just the active one
    const total = Object.values(m).reduce((sum, ids) => sum + (ids || []).length, 0);
    setSelectedCount(total);
  }, [version, activeSubjectKey]);

  const showUnderWarning = dateRangeComplete && selectedCount > 0 && selectedCount < totalSlotsRequired;
  const showOverWarning  = dateRangeComplete && selectedCount > totalSlotsRequired;

  // ── Filters ──────────────────────────────────────────────────────────────
  // Compute the topic IDs that should go into the filter for a given chapter:
  // - If user has manually picked specific topics → use only those
  // - Otherwise → use all topics for that chapter from topicsByChapter
  const getTopicsForChapter = useCallback((chapterId) => {
    const allForChapter = topicsByChapter[chapterId] || [];
    if (selectedTopicIds.length === 0) return allForChapter;
    return selectedTopicIds.filter((tid) => allForChapter.includes(tid));
  }, [selectedTopicIds, topicsByChapter]);

  const filters = useMemo(() => {
    if (!selectedSubjectId || !allTopicsLoaded) return [];

    // ── Stale chapter IDs guard ──────────────────────────────────────────────
    // If selectedChapterIds belong to a previous subject (chapters state not
    // yet updated), return empty and wait for both to sync before sending filter
    if (selectedChapterIds.length > 0) {
      const chapterIdSet = new Set(chapters.map((ch) => ch.chapter_id));
      const allMatch = selectedChapterIds.every((id) => chapterIdSet.has(id));
      if (!allMatch) return []; // stale — chapters and chapterIds out of sync
    }

    const chapsToUse = selectedChapterIds.length > 0
      ? chapters.filter((ch) => selectedChapterIds.includes(ch.chapter_id))
      : chapters;

    if (!chapsToUse.length) return [];

    const chapList = chapsToUse.map((ch) => ({
      chapter_id: ch.chapter_id,
      topics: getTopicsForChapter(ch.chapter_id), // empty array is fine
    }));

    // ── Removed: if (!chapList.some((c) => c.topics.length > 0)) return []; ──
    // Chapters with no topics are valid — questions API should still be called

    return [{ ques_types: [{ ques_type_id: 1, chapters: chapList }] }];
  }, [selectedSubjectId, selectedChapterIds, selectedTopicIds, chapters, topicsByChapter, allTopicsLoaded, getTopicsForChapter]);

  const memoizedTags    = useMemo(() => selectedTags, [JSON.stringify(selectedTags)]);
  const memoizedFilters = useMemo(() => filters,      [JSON.stringify(filters)]);

  // ── APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!accessToken) return;
    fetch(Endpoints.PRISM_GET_COURSES, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => r.json()).then((d) => setCourses(Array.isArray(d) ? d : d?.data || []));
  }, [accessToken]);

  useEffect(() => {
    setSubjects([]); setSelectedSubjectId(""); setChapters([]);
    setSelectedChapterIds([]); setSelectedTopicIds([]); setTopicsByChapter({}); setAllTopicsLoaded(false);
    if (!selectedCourseId || !accessToken) return;
    fetch(`${Endpoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => r.json()).then((d) => setSubjects(Array.isArray(d) ? d : d?.data || []));
  }, [selectedCourseId]);

  // When subject changes: fetch all chapters, then auto-select all
  // NOTE: Questions per subject are retained via localStorage keyed by activeSubjectKey
  useEffect(() => {
    setChapters([]); setSelectedChapterIds([]); setSelectedTopicIds([]);
    setTopicsByChapter({}); setAllTopicsLoaded(false);

    // Stamp the ref so we can detect if subject changed again before fetch completes
    filterSubjectRef.current = selectedSubjectId;

    if (!selectedSubjectId || !accessToken) return;
    fetch(`${Endpoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => r.json())
      .then((d) => {
        // Guard: if subject changed again while this fetch was in flight, discard result
        if (filterSubjectRef.current !== selectedSubjectId) return;
        const list = Array.isArray(d) ? d : d?.data || [];
        setChapters(list);
        setSelectedChapterIds(list.map((ch) => ch.chapter_id));
      });
  }, [selectedSubjectId]);

  // When chapters load: fetch topics for every chapter in parallel, then auto-select all topics
  useEffect(() => {
    if (!chapters.length || !accessToken) {
      setTopicsByChapter({}); setAllTopicsLoaded(false); return;
    }
    setAllTopicsLoaded(false);
    let completed = 0;
    const result = {};
    const nameMap = {};
    chapters.forEach((ch) => {
      fetch(`${Endpoints.PRISM_GET_TOPICS_BY_CHAPTER}?chapter_id=${ch.chapter_id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
        .then((r) => r.json())
        .then((data) => {
          const topicList = Array.isArray(data) ? data : data?.data || [];
          result[ch.chapter_id] = topicList.map((t) => t.topic_id);
          topicList.forEach((t) => { nameMap[t.topic_id] = t.topic_name; });
          completed++;
          if (completed === chapters.length) {
            setTopicsByChapter({ ...result });
            setTopicNameMap({ ...nameMap });
            setSelectedTopicIds(Object.values(result).flat());
            setAllTopicsLoaded(true);
          }
        })
        .catch(() => {
          completed++;
          if (completed === chapters.length) {
            setTopicsByChapter({ ...result });
            setTopicNameMap({ ...nameMap });
            setAllTopicsLoaded(true);
          }
        });
    });
  }, [chapters]);

  useEffect(() => {
    if (!accessToken) return;
    fetch(Endpoints.PRISM_GET_PARSE_TAGS_ALL, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => r.json()).then((d) => { if (d.data) setTags(d.data); });
  }, [accessToken]);

  // ── Tag handlers ─────────────────────────────────────────────────────────
  const handleDropdownChange = (tag, opt) =>
    setSelectedTags((prev) => {
      const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
      return opt?.id != null ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: opt.id }] : f;
    });

  const handleCheckboxChange = (tag, checked) =>
    setSelectedTags((prev) => {
      const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
      return checked ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: 1 }] : f;
    });

  // ── Save ─────────────────────────────────────────────────────────────────
  const proceedToSave = async () => {
    const scheduleData = [];
    Object.entries(sectionWiseQuestions).forEach(([scheduledDate, questions]) => {
      questions.forEach((q) => {
        scheduleData.push({
          scheduled_date: scheduledDate,
          parse_ques_set_question_id: q.id,
          course_id: selectedCourseId ? parseInt(selectedCourseId) : 0,
        });
      });
    });

    if (scheduleData.length === 0) {
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>No questions assigned to any date. Please select questions and assign them to dates.</span>
          </div>
          <div className="messagebox-insider2" style={{ marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      return;
    }

    setActiveImg(InfoIcon);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Saving MCQ schedule...</span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);

    try {
      const res = await fetch(Endpoints.PRISM_CREATE_MCQ_SCHEDULE, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          user_name: userName,
          schedule_data: scheduleData,
        }),
      });
      const data = await res.json();

      if (data.status === 200) {
        // ── Clear all MCQ localStorage on successful save ──────────────────
        localStorage.removeItem("mcqDateAssignments");
        localStorage.removeItem("subjectWiseSelectedRowIds");
        localStorage.removeItem("subjectWiseDeletedRowIds");
        localStorage.removeItem("mcqRowDataStore");

        setActiveImg(InfoIcon);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{data.message || "MCQ schedule saved successfully!"}</span>
            </div>
            <div className="messagebox-insider2" style={{ marginTop: 10 }}>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => { setIsMessageBoxVisible(false); navigate("/mcq_dashboard"); }}
              >
                OK
              </button>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
      } else {
        throw new Error(data.message || "Failed to save MCQ schedule");
      }
    } catch (err) {
      console.error("MCQ save error:", err);
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Failed to save MCQ schedule. Please try again. {err.message}</span>
          </div>
          <div className="messagebox-insider2" style={{ marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
    }
  };

  const handleSave = () => {
    if (!dateRangeComplete) {
      setActiveImg(WarnningIcon);
      setMessageBox(<div><p>Please complete the date range settings first.</p></div>);
      setIsMessageBoxVisible(true); return;
    }
    if (!selectedSubjectId) {
      setActiveImg(ErrorIcon);
      setMessageBox(<div><p>Please select a subject before saving.</p></div>);
      setIsMessageBoxVisible(true); return;
    }
    if (showUnderWarning) {
      setNoTimeSet?.(true);
      setActiveImg(WarnningIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Only {selectedCount} of {totalSlotsRequired} required questions selected. Some dates will have fewer questions. Save anyway?</span>
          </div>
          <div className="messagebox-insider2" style={{ display: "flex", gap: 10, marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>CANCEL</button>
            <button className="messagebox-cancel-btn-ok" onClick={() => {
              setIsMessageBoxVisible(false);
              proceedToSave();
            }}>SAVE ANYWAY</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true); return;
    }
    proceedToSave();
  };

  // ── All selected rows merged across ALL subjects ─────────────────────────
  // Used for selectedRows prop — keeps checkboxes in sync across subjects
  const allSelectedQuestions = Object.values(selectedQuestionsBySubject).flat();
  const allSelectedRows      = Object.values(selectedRowsBySubject).flat();

  // ── Stable selected questions for the SELECTED table ─────────────────────
  // Reads from mcqRowDataStore (localStorage) which is written whenever any
  // subject's question list loads. This means ALL subjects' selected rows
  // are always available regardless of which subject is currently active.
  //
  // IMPORTANT: reportDashboardData rows have row[0]=questionId (TableQuesList format)
  // TableDetailsSelectedQues reads row[1] as questionId — so rows are in the SAME
  // format as reportDashboardData (the component handles both internally via headers).
  // We pass rows as-is from the store.
  const stableSelectedQuestions = useMemo(() => {
    const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    const store  = JSON.parse(localStorage.getItem(STORE_KEY) || "{}");
    const allIds = Array.from(new Set(Object.values(selMap).flat().map(String)));
    if (allIds.length === 0) return [];

    return allIds.map((qid) => {
      // Try localStorage row store (survives all subject switches)
      if (store[qid]) {
        try {
          const row = JSON.parse(store[qid]);
          return row;
        } catch (_) {}
      }
      // Fallback: scan current reportDashboardData (row[0] = ID)
      const fromReport = reportDashboardData.find((r) => String(r[0]) === qid);
      if (fromReport) return fromReport;
      // Placeholder until that subject's question list loads and caches the row
      return [qid, qid, `Question ${qid}`, "", "", "", ""];
    });
  }, [version, reportDashboardData]);

  // ── Computed min date for FROM input ──────────────────────────────────────
  const minFromDate = getMinFromDate(serverCurrentTime);

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div className="create-role-container">

      {/* Top bar */}
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">MCQ of the Day</span>
        <div className="create-test-section-btns-container-ques-paper-dels">
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={() => {
              localStorage.removeItem("mcqDateAssignments");
              localStorage.removeItem("subjectWiseSelectedRowIds");
              localStorage.removeItem("subjectWiseDeletedRowIds");
              localStorage.removeItem("mcqRowDataStore");
              navigate('/mcq_dashboard');
            }}
          >CANCEL</button>
          <button
            className="create-test-section-btn-ques-paper-del"
            style={{ marginRight: 0, boxShadow: "0px 4px 4px 0px #00000040" }}
            onClick={handleSave}
            onMouseEnter={(e) => { e.target.style.backgroundColor = "#fa4741"; e.target.style.color = "white"; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; }}
          >SAVE</button>
        </div>
      </div>

      {/* ── SECTION 1: Date Range & Frequency ─────────────────────────── */}
      <div className="display-ques-paper-del" style={{ marginTop: 20 }}>
        <div className="personal-header">
          <div className="header"><label>DATE RANGE &amp; FREQUENCY</label></div>
          <div className="accordion-btn" onClick={() => setIsOpenDateRange((o) => !o)}>
            {isOpenDateRange ? <div className="minus" /> : <div className="plus">+</div>}
          </div>
        </div>
        {isOpenDateRange && (
          <div className="accordion-content">
            <div className="motd-grid-3">

              {/* ── FROM DATE ── */}
              <div className="motd-date-field">
                <label className="motd-label">From</label>
                <input
                  type="date"
                  className="motd-date-input"
                  value={fromDate}
                  min={minFromDate}
                  max={toDate || undefined}
                  onChange={(e) => {
                    const newFrom = e.target.value;

                    // Block dates before minimum (browser min attr handles UI,
                    // this is a safety guard for manual input)
                    if (newFrom < minFromDate) return;

                    // If date range was previously complete, clear all selections
                    // so user re-assigns questions to the new date range
                    if (dateRangeComplete) {
                      clearAllSelections();
                    }

                    setFromDate(newFrom);

                    // If toDate is now before new fromDate, clear it
                    if (toDate && newFrom > toDate) {
                      setToDate("");
                    }
                  }}
                />
              </div>

              {/* ── TO DATE ── */}
              <div className="motd-date-field">
                <label className="motd-label">To</label>
                <input
                  type="date"
                  className="motd-date-input"
                  value={toDate}
                  min={fromDate || minFromDate}
                  onChange={(e) => {
                    // If date range was previously complete, clear all selections
                    if (dateRangeComplete) {
                      clearAllSelections();
                    }
                    setToDate(e.target.value);
                  }}
                />
              </div>

              {/* ── FREQUENCY ── */}
              <div className="motd-date-field">
                <SectionSelectedDropdown
                  label="Frequency"
                  selected={frequency}
                  setSelected={(val) => {
                    // Clear selections when frequency changes as date slots change
                    if (dateRangeComplete) {
                      clearAllSelections();
                    }
                    setFrequency(val);
                  }}
                  options={FREQUENCY_OPTIONS}
                  Height="auto" OverFlow="auto" minheight="200px"
                />
              </div>

              {/* ── QUESTIONS PER DAY ── */}
              <div className="motd-date-field">
                <SectionSelectedDropdown
                  label="Questions per Day (max 3)"
                  selected={numQuestions}
                  setSelected={(val) => {
                    // Clear selections when questions per day changes as slot count changes
                    if (dateRangeComplete) {
                      clearAllSelections();
                    }
                    setNumQuestions(val);
                  }}
                  options={NUM_QUES_OPTIONS}
                  Height="auto" OverFlow="auto" minheight="120px"
                />
              </div>

            </div>
          </div>
        )}
      </div>

      {/* ── SECTION 2: Subject & Tags Filter (merged) ─────────────────── */}
      <div
        className={`display-ques-paper-del motd-lockable${!dateRangeComplete ? " motd-locked" : ""}`}
        style={{ marginTop: 20 }}
      >
        <div className="personal-header">
          <div className="header">
            <label>SUBJECT &amp; TAGS FILTER</label>
          </div>
          <div className="accordion-btn" onClick={() => dateRangeComplete && setIsOpenSubjectTags((o) => !o)}>
            {isOpenSubjectTags ? <div className="minus" /> : <div className="plus">+</div>}
          </div>
        </div>

        {isOpenSubjectTags && (
          <div className="accordion-content">
            <div className="motd-grid-3">
              <SectionSelectedDropdown
                label="Course"
                selected={selectedCourseId}
                setSelected={(v) => {
                  setSelectedCourseId(v);
                  setSelectedSubjectId("");
                  setSelectedChapterIds([]);
                  setSelectedTopicIds([]);
                  setTopicsByChapter({});
                  setAllTopicsLoaded(false);
                }}
                options={courses.map((c) => ({ id: c.course_id, label: c.course_name }))}
                Height="auto" OverFlow="auto" minheight="300px"
                disabled={!dateRangeComplete}
              />
              <SectionSelectedDropdown
                label="Subject"
                selected={selectedSubjectId}
                setSelected={(v) => {
                  // Subject switch retains previous subject's questions via
                  // localStorage key (activeSubjectKey = selectedSubjectId)
                  setSelectedSubjectId(v);
                  setSelectedChapterIds([]);
                  setSelectedTopicIds([]);
                }}
                options={subjects.map((s) => ({ id: s.subject_superset_id, label: s.subject_superset_name }))}
                Height="auto" OverFlow="auto" minheight="300px"
                disabled={!dateRangeComplete || !selectedCourseId}
              />
              <MultiSelectSearchDropdown
                label="Chapter"
                selected={selectedChapterIds}
                setSelected={(ids) => {
                  setSelectedChapterIds(ids);
                  const allTopics = ids.flatMap((cid) => topicsByChapter[cid] || []);
                  setSelectedTopicIds([...new Set(allTopics)]);
                }}
                options={chapters.map((ch) => ({ id: ch.chapter_id, label: ch.chapter_name }))}
                showSelectAll
                disabled={!dateRangeComplete || !selectedSubjectId}
                placeholder={allTopicsLoaded ? "" : "Loading…"}
              />
              <MultiSelectSearchDropdown
                label="Topic"
                selected={selectedTopicIds}
                setSelected={setSelectedTopicIds}
                options={
                  (selectedChapterIds.length > 0 ? selectedChapterIds : chapters.map((ch) => ch.chapter_id))
                    .flatMap((cid) => (topicsByChapter[cid] || []).map((tid) => ({
                      id: tid,
                      label: topicNameMap[tid] || String(tid),
                    })))
                    .filter((opt, idx, arr) => arr.findIndex((o) => o.id === opt.id) === idx)
                }
                showSelectAll
                disabled={!dateRangeComplete || !selectedSubjectId}
                placeholder={allTopicsLoaded ? "" : "Loading…"}
              />
              {tags.filter((tag) => tag.parse_tag_type === 1 && tag.parse_tag_id !== 8).map((tag) => (
                <div key={tag.parse_tag_id}>
                  <DropDownFilterTags
                    label={tag.parse_tag_name}
                    setSelected={(opt) => handleDropdownChange(tag, opt)}
                    options={tag.parse_tag_value.map((v) => ({ label: v.tag_value, id: v.parse_tag_value_id }))}
                    selected={selectedTags.find((t) => t.tag_id === tag.parse_tag_id)?.tag_value_id || null}
                    disabled={!dateRangeComplete}
                  />
                </div>
              ))}
            </div>

            {/* Divider */}
            <div className="motd-section-divider" />

            {/* type-2 checkboxes */}
            <div className="display-test-data-container-ques-paper-del-filter-tags">
              <div className="display-grid-container-ques-paper-del-filter-tags">
                {tags.filter((tag) => tag.parse_tag_type === 2).map((tag) => (
                  <div className="grid-item" key={tag.parse_tag_id}>
                    <div className="check-box-tag-impt">
                      <input
                        type="checkbox"
                        id={`motd-chk-${tag.parse_tag_id}`}
                        className="cr-custom-checkbox-tags"
                        onChange={(e) => handleCheckboxChange(tag, e.target.checked)}
                        checked={selectedTags.some((t) => t.tag_id === tag.parse_tag_id && t.tag_value_id === 1)}
                        disabled={!dateRangeComplete}
                      />
                      <label htmlFor={`motd-chk-${tag.parse_tag_id}`}>{tag.parse_tag_name}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ── SECTION 3: Questions List ──────────────────────────────────── */}
      <div className="create-ques-paper-ques-list-container-text" style={{ marginTop: 20 }}>
        <span>QUESTIONS LIST</span>
      </div>
      <div className="create-ques-paper-ques-list-container">
        <TableDetailsQuesList
          selectedTags={memoizedTags} filters={memoizedFilters}
          setMessageBox={setMessageBox} messageBox={messageBox}
          setIsMessageBoxVisible={setIsMessageBoxVisible} setActiveImg={setActiveImg}
          setNoTimeSet={setNoTimeSet} dataClient={null}
          setSelectedQuestions={setSelectedQuestions} setSelectedHeaders={setSelectedHeaders}
          setDifficultyCount={setDifficultyCount} userId={userId}
          showFlagModal={showFlagModal} setShowFlagModal={setShowFlagModal}
          subjectId={selectedSubjectId ? parseInt(selectedSubjectId) : null}
          courseId={selectedCourseId  ? parseInt(selectedCourseId)  : null}
          scopeRefIds={[0]} setReportDashboardData={setReportDashboardData}
          reportDashboardData={reportDashboardData} draftData={null}
          selectedRows={selectedRows} setSelectedRows={setSelectedRows}
          selectedQuestions={selectedQuestions} activeSubjectId={activeSubjectKey}
          setVersion={handleVersionChange} excludeRepeatCount={0} clientBranchId={clientBranchId}
          scopeId={0} loadingTab={false} setLoadingTab={() => {}} isReadOnly={false}
        />
      </div>

      {/* ── SECTION 4: Selected Questions ─────────────────────────────── */}
      <div className="create-ques-paper-ques-selected-container-text" style={{ marginTop: 20 }}>
        <span>SELECTED QUESTIONS</span>
      </div>
      <div className="create-ques-paper-ques-selected-container">
        <TableDetailsSelectedQues
          selectedQuestions={stableSelectedQuestions} selectedHeaders={selectedHeaders}
          selectedSections={1}
          setSectionWiseQuestions={setSectionWiseQuestions} selecteSectionTypeID={1}
          setIsMessageBoxVisible={setIsMessageBoxVisible} setActiveImg={setActiveImg}
          setMessageBox={setMessageBox} allQuesList={reportDashboardData}
          setSelectedQuestions={setSelectedQuestions} selectedRows={allSelectedRows}
          setSelectedRows={setSelectedRows} draftData={null} isReadOnlyMode={false}
          setDifficultyCount={setDifficultyCount} activeSubjectId={activeSubjectKey}
          version={version} setVersion={handleVersionChange}
          sectionWiseQuestions={sectionWiseQuestions}
          customSectionOptions={customSectionOptions}
          sectionColumnLabel="Schedule Date"
          numQuestionsPerDate={numQuestions || 1}
        />
      </div>
    </div>
  );
}